module.exports = __webpack_public_path__ + "static/media/iconTwo.51258581.svg";